<template>
  <TaskPanel
    :taskInfos="taskInfos"
    :titleImage="titleImage"
    :buttonImage="buttonImage"
    :taskStatusTextMap="taskStatusTextMap"
    @doTask="handleDoTask"
    @refreshTaskInfo="refreshTaskInfo"
    @reportClick="reportClick"
    @reportCollapseSwitch="reportCollapseSwitch"
    @launchShare="handleLaunchShare"
  />
</template>
<script>
import { mapActions, mapState } from 'vuex';
import TaskPanel from './BaseTaskPanel';
import share from '../mixins/share';

export default {
  components: { TaskPanel },
  mixins: [share],
  props: {
    titleImage: {
      type: String,
      required: true
    },
    buttonImage: {
      type: String,
      required: true
    },
    moduleName: String
  },
  computed: {
    ...mapState('app', {
      taskInfos: function(state) {
        return state[this.moduleName].actData.taskInfos || [];
      },
      taskStatusTextMap() {
        if (this.$uiTheme === 'lalamove') {
          return {
            // 完成n单
            order_complete_n: {
              incomplete: this.$t('task_panel.do_task'),
              tomorrowAble: null,
              tomorrowUnable: this.$t('task_panel.completed')
            },
            // 完成1单
            complete_first_order: {
              incomplete: this.$t('task_panel.do_task'),
              tomorrowAble: null,
              tomorrowUnable: this.$t('task_panel.completed')
            },
            // 每日签到
            sign_in: {
              incomplete: this.$t('task_panel.do_task'),
              tomorrowAble: this.$t('task_panel.try_tomorrow'),
              tomorrowUnable: this.$t('task_panel.completed')
            }
          };
        }
        return null;
      }
    })
  },
  mounted() {
    this.$emit('reportEvent', {
      event: 'lottery_topic_expo',
      module_name: '1005'
    });
  },
  methods: {
    ...mapActions('app', {
      doTask: function(dispatch, ...props) {
        return dispatch(`${this.moduleName}/doTask`, ...props);
      },
      refreshTaskInfo: function(dispatch) {
        dispatch(`${this.moduleName}/refreshTaskInfo`);
      }
    }),
    async handleDoTask(taskId, callback) {
      await this.doTask(taskId);
      callback && callback();
    },
    async handleLaunchShare(options, callback) {
      try {
        const target = await this.launchShare(options);
        callback(target);
        this.reportShare(target);
      } catch (error) {
        this.$hll.toast(error && error.msg);
      }
    },
    reportClick({ task, button_name }) {
      this.$emit('reportEvent', {
        event: 'lottery_task_click',
        module_name: '1005',
        task_ids: task.taskId,
        button_name
      });
    },
    reportShare(target) {
      const targetNameMap = {
        wechat1: 'W',
        wechatn: 'P'
      };
      this.$emit('reportEvent', {
        event: 'lottery_share_click',
        module_name: '任务列表_去分享',
        button_name: targetNameMap[target]
      });
    },
    reportCollapseSwitch({ button_name }) {
      this.$emit('reportEvent', {
        event: 'lottery_task_click',
        module_name: '1005',
        button_name
      });
    }
  }
};
</script>
